<template>
  <div class="company-details-wrapper fullheight">
    <div class="company-cover-wrapper pos-relative" v-if="company" :style="company.cover_photo | setBackgroundImage">
      <div class="overlay"></div>
      <!-- <img :src="company.cover_photo" :alt="company.name" class="cover-photo centered" width="100%"> -->
      <div class="logo-name-container">
        <div style="max-width:1300px;margin:auto">
          <Row class="logo-name-wrapper" :gutter="20" type="flex" justify="start">
            <i-col :xs="24" :sm="12" :md="5">
              <img :src="(company.logo)? company.logo : require('@/assets/images/logo/default-company-logo.png')" :alt="company.name" class="cover-photo" width="200" height="200">
            </i-col>
            <i-col :xs="24" :sm="12" :md="19">
              <h1>{{ company.name }}</h1>
              <p style="margin-top:100px">{{ company.tagline }}</p>
            </i-col>
          </Row>
        </div>
      </div>
    </div>
    <div class="k-page" v-if="company">
      <Button type="text" class="padding-t-20" icon="md-arrow-back" size="large" style="color:#57a3f3" @click="backToResults">Back to Results</Button>
      <Input v-model="searchedText" class="padding-t-20 padding-lr-20 search-container" @on-enter="handleRedirectFilter" placeholder="New Keyword Search">
        <Button slot="append" icon="ios-options" style="border-top-left-radius:0px;border-bottom-left-radius:0px;height:50px;background:gray;color:#fff;" @click="handleRedirectFilter">Filter</Button>
      </Input>
      <div class="page-menu">
        <Menu mode="horizontal" active-name="1">
          <MenuItem name="1">
            Details
          </MenuItem>
        </Menu>
      </div>
      <div class="company-socil-media-container">
        <Row class="company-socil-media-wrapper" :gutter="20" type="flex" justify="center">
          <Col :xs="12" :sm="6" :md="6" class="text-center">
            <a style="color:#515a6e" :href="company.website" target="_blank">
              <Button size="large" long>
                <Icon type="md-browsers" color="#b00101" />
                Website
              </Button>
            </a>
          </Col>
          <Col :xs="12" :sm="6" :md="6" class="text-center">
            <Button size="large" @click="handleBookmark(company.is_bookmark)" long>
              <Icon :type="(company.is_bookmark)? 'ios-bookmark':'ios-bookmark-outline'" size="15" :color="(company.is_bookmark)?'#b00101':''" style="font-weight:bold"/>
              Bookmark
            </Button>
          </Col>
          <Col :xs="12" :sm="6" :md="6" class="text-center">
            <Button size="large" @click="handleShare" long>
              <Icon type="md-share" color="#b00101" />
              Share
            </Button>
          </Col>
          <Col :xs="12" :sm="6" :md="6" class="text-center">
            <a href="mailto:webmaster@kromnix.com">
              <Button size="large" long>
                <Icon type="ios-warning-outline" color="#b00101" />
                Report
              </Button>
            </a>
          </Col>
        </Row>
      </div>
      <div class="company-information-container padding-20">
        <Row class="company-information-wrapper" :gutter="20">
          <Col :xs="24" :sm="24" :md="12">
            <Card>
              <h3><Icon type="md-contact" size="20"/> ABOUT</h3>
              <div class="padding-20">
                <p v-if="company.name" class="padding-b-20">Company name : {{ company.name }}</p>
                <p v-if="company.tagline" class="padding-b-20">Tagline : {{ company.tagline }}</p>
                <p v-if="company.size" class="padding-b-20">Company size : {{ company.size }}</p>
                <p v-if="company.founded" class="padding-b-20">Founded in : {{ company.founded }}</p>
                <p v-if="company.founder" class="padding-b-20">Founder(s) : {{ company.founder }}</p>
                <p v-if="company.founder" >Website : {{ company.website }}</p>
              </div>
            </Card>
            <Card v-if="company.categories.length">
              <h3><Icon type="md-link" size="20"/> TECHNOLOGY CATEGORIES</h3>
              <Row class="padding-20" :gutter="20">
                <i-col :xs="24" :sm="12" :md="8" v-for="(cat, idx) in company.categories" :key="idx" class="text-center">
                  <Avatar icon="logo-buffer" size="40"/>
                  <p>{{ cat }}</p>
                </i-col>
              </Row>
            </Card>
            <Card v-if="company.marketapplications.length">
              <h3><Icon type="md-menu" size="20"/> MARKET APPLICATIONS</h3>
              <Row class="padding-20" :gutter="20">
                <i-col :xs="24" :sm="12" :md="8" v-for="(cat, idx) in company.marketapplications" :key="idx" class="text-center">
                  <Avatar icon="ios-bookmark-outline" size="40"/>
                  <p>{{ cat }}</p>
                </i-col>
              </Row>
            </Card>
            <Card v-if="company.tags">
              <h3><Icon type="md-pricetag" size="20"/> TAGS</h3>
              <div class="padding-20">
                {{ company.tags }}
              </div>
            </Card>
            <Card v-if="company.solutions_to_problems">
              <h3><Icon type="md-warning" size="20"/> PROBLEMS WE CAN SOLVE / OUR SOLUTIONS</h3>
              <div class="padding-20" v-html="company.solutions_to_problems"></div>
            </Card>
            <Card v-if="company.reference">
              <h3><Icon type="md-people" size="20"/> CUSTOMER REFERENCES</h3>
              <div class="padding-20" v-html="company.reference"></div>
            </Card>
            <Card v-if="company.sns.length">
              <h3><Icon type="md-share" size="20"/> FOLLOW US</h3>
              <Row class="padding-20" :gutter="20">
                <i-col :xs="24" :sm="12" :md="8" v-for="(cat, idx) in company.sns" :key="idx" class="text-center" style="margin-bottom:10px;">
                  <a :href="cat.url" target='_blank' style="color:#515a6e">
                    <Avatar :icon="social_networks.find(item => item.value === cat.type).icon" size="40"/>
                    <p>{{ cat.type }}</p>
                  </a>
                </i-col>
              </Row>
            </Card>
            <Card v-if="company.responsible_company.length">
              <h3><Icon type="ios-keypad" size="20"/> RESPONSIBLE COMPANY</h3>
              <div class="padding-20">
                <div v-if="company.responsible_company[0].gdr_compliance">
                  <h4>GDPR compliance</h4>
                  <p v-html="company.responsible_company[0].gdr_compliance"></p><br/>
                </div>
                <div v-if="company.responsible_company[0].web_hosting_location">
                  <h4>Web hosting location</h4>
                  <p v-html="company.responsible_company[0].web_hosting_location"></p><br/>
                </div>
                <div v-if="company.responsible_company[0].security_certification">
                  <h4>Security certification</h4>
                  <p v-html="company.responsible_company[0].security_certification"></p><br/>
                </div>
                <div v-if="company.responsible_company[0].green_initiative">
                  <h4>Green initiatives </h4>
                  <p v-html="company.responsible_company[0].green_initiative"></p><br/>
                </div>
                <div v-if="company.responsible_company[0].green_label">
                  <h4>Green labels</h4>
                  <p v-html="company.responsible_company[0].green_label"></p><br/>
                </div>
                <div v-if="company.responsible_company[0].csr_certification">
                  <h4>CSR certifications</h4>
                  <p v-html="company.responsible_company[0].csr_certification"></p>
                </div>
              </div>
            </Card>
            <Card v-if="company.gallery.length">
              <h3><Icon type="md-share" size="20"/> GALLERY</h3>
              <div class="padding-20">
                <Row type="flex" justify="center">
                  <i-col :xs="24" :sm="12" :md="6" :lg="8" v-for="(img, idx) in company.gallery" :key="idx" >
                    <viewer :images="company.gallery" class="viewer" ref="viewer">
                      <Avatar shape="square" :src="img.file" :size="150" class="clickable"/>
                    </viewer>
                  </i-col>
                </Row>
              </div>
            </Card>
            <Card v-if="company.video_url">
              <h3><Icon type="md-camera" size="20"/> VIDEO</h3>
              <div class="padding-20">
                <youtube class="k-video-player" :video-id="company.video_id" ref="youtube"></youtube>
              </div>
            </Card>
            <Card v-if="company.file_download.length">
              <h3><Icon type="md-document" size="20"/> DOWNLOADS</h3>
              <div class="padding-20">
                <Row justify="center" align="middle" :gutter="20" v-for="(file, idx) in company.file_download" :key="idx" class="message-file-row">
                  <i-col flex="30px">
                    <div class="icon-con pos-relative">
                      <Icon type="ios-document-outline" size="22" class="centered"/>
                    </div>
                  </i-col>
                  <i-col flex="auto">
                    <p class="ellipsis" style="max-width:90%;">{{ file.file | getFileName }}</p>
                  </i-col>
                  <i-col flex="30px">
                    <a :href="`${downloadFileUrl}${file.id}/`">
                      <Icon :type="(downloading)? 'ios-loading':'md-download'" @click="handleDownloadDocument" class="clickable"/>
                    </a>
                  </i-col>
                </Row>
              </div>
            </Card>
          </Col>
          <Col :xs="24" :sm="24" :md="12">
            <Card v-if="company.description">
              <h3><Icon type="md-apps" size="20"/> COMPANY OVERVIEW</h3>
              <div class="padding-20" v-html="company.description"></div>
            </Card>
            <Card v-if="company.address">
              <h3><Icon type="md-home" size="20"/> HEADQUARTERS OFFICE</h3>
              <div class="padding-20">
                {{ company.address }}
              </div>
            </Card>
            <Card v-if="company.latitude || company.longitude || company.address">
              <Row type="flex" justify="space-between" class="padding-b-20">
                <i-col><h3><Icon type="md-pin" size="20"/> MAP LOCATION</h3></i-col>
                <i-col>
                  <a v-if="company.latitude && company.longitude" :href="`http://www.google.com/maps/place/${company.latitude},${company.longitude}`" target="_blank" class="text-right">Get directions</a>
                  <a v-else-if="company.address" :href="`http://maps.google.com/?q=${company.address}`" target="_blank" class="text-right">Get directions</a>
                </i-col>
              </Row>
              <div class="padding-tb-20" style="min-height:350px" v-if="company.latitude && company.longitude">
                <MglMap :accessToken="mapboxAccessToken" :mapStyle.sync="mapStyle" id="vue-mapbox-mglmap" @load="onMapLoaded" :zoom="15" :center="[company.longitude, company.latitude]">
                  <MglNavigationControl position="bottom-right" />
                  <MglFullscreenControl position="bottom-right" />
                  <MglMarker :coordinates="[company.longitude, company.latitude]" color="red" />
                </MglMap>
              </div>
              <div v-else-if="company.address" class="padding-tb-20" style="min-height:350px" >
                <MglMap :accessToken="mapboxAccessToken" :mapStyle.sync="mapStyle" id="vue-mapbox-mglmap" @load="onMapLoaded" :zoom="15" :center="coordinates">
                  <MglNavigationControl position="bottom-right" />
                  <MglFullscreenControl position="bottom-right" />
                </MglMap>
              </div>
            </Card>
            <Card v-if="company.other_location">
              <h3><Icon type="ios-globe" size="20"/> OTHER LOCATION</h3>
              <div class="padding-20" v-html="company.other_location"></div>
            </Card>
            <Card>
              <h3><Icon type="md-mail" size="20"/> CONTACT US</h3>
              <div class="padding-20">
                <ContactForm :techCompany="company.id"/>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <Interests :categoryId="company.newcategory[0]" :companyId="company.id"/>
    </div>
    <SocialMediaShare ref="SocialMediaShare" :title="company.name" :url="currentUrl"/>
    <Spin size="large" fix v-if="isLoading"></Spin>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'

import { component as Viewer } from 'v-viewer'
import { fetchCompanyBySlug } from '@/services/companies'
import { AppMixins } from '@/utils/appMixins'
import ContactForm from './ContactForm'
import { addBookmark, deleteBookmark } from '@/services/bookmarks'
import SocialMediaShare from '@/components/ui/SocialMediaShare'
import Interests from './Interests'
import { MglMap, MglNavigationControl, MglMarker, MglFullscreenControl } from 'vue-mapbox'
import { getIdFromUrl } from 'vue-youtube'
import axios from 'axios'
import mapboxgl from 'mapbox-gl'

export default {
  mixins: [AppMixins],

  components: {
    ContactForm,
    SocialMediaShare,
    Interests,
    MglMap,
    MglNavigationControl,
    MglFullscreenControl,
    MglMarker,
    Viewer
  },

  data () {
    return {
      downloading: false,
      searchedText: null,
      isLoading: false,
      company: null,
      currentUrl: window.location.origin + window.location.pathname,
      downloadFileUrl: process.env.VUE_APP_API_URL + 'file-downloads/',
      mapboxAccessToken: process.env.VUE_APP_MAPBOX_API_KEY,
      mapStyle: 'mapbox://styles/mapbox/streets-v11',
      coordinates: [0, 0]
    }
  },

  filters: {
    setBackgroundImage (val) {
      if (val) {
        return { backgroundImage: 'url(' + val + ')' }
      } else {
        return { backgroundImage: 'url(' + require('@/assets/images/default-cover-photo.jpg') + ')' }
      }
    },
    getFileName (url) {
      if (url) {
        return new URL(url).pathname.split('/').pop()
      }
      return ''
    }
  },

  mounted () {
    this.getCompanyDetails()
  },

  created () {
    this.mapbox = null
  },

  methods: {
    onMapLoaded (event) {
      this.map = event.map
      document.querySelectorAll('.mapboxgl-marker.mapboxgl-marker-anchor-center').forEach(el => el.remove())
      new mapboxgl.Marker().setLngLat(this.coordinates).addTo(this.map)
    },

    getCompanyDetails () {
      this.isLoading = true
      fetchCompanyBySlug(this.$route.params.slug).then(async res => {
        if (res.data.latitude === null && res.data.longitude === null) {
          if (res.data.address) {
            this.coordinates = await this.getMapCoordinates(res.data.address)
          }
        }
        this.company = res.data
        if (res.data.video_url) this.company.video_id = getIdFromUrl(res.data.video_url)
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to fetch company by slug: ', err)
      })
    },

    async getMapCoordinates (add) {
      const response = await axios.get(`${process.env.VUE_APP_MAPBOX_API_URL}${add}.json?access_token=${this.mapboxAccessToken}`)
      return response.data.features[0].center
    },

    getMarkerOptions () {
      return {
        url: this.company.logo,
        size: { width: 60, height: 90, f: 'px', b: 'px' },
        scaledSize: { width: 30, height: 45, f: 'px', b: 'px' }
      }
    },

    handleShare () {
      this.$refs.SocialMediaShare.openModal()
    },

    addBookmark (data) {
      addBookmark(data).then(res => {
        this.$Message.success('Tech provider bookmarked successfully')
      }).catch(err => {
        console.log('Failed to add book mark: ', err)
      })
    },

    deleteBookmark (companyId) {
      deleteBookmark(companyId).then(res => {
        this.$Message.success('Tech provider removed from bookmark successfully')
      }).catch(err => {
        console.log('Failed to remove book mark: ', err)
      })
    },

    handleBookmark (isMarked) {
      if (localStorage.getItem('_id')) {
        if (isMarked) {
          this.deleteBookmark(this.company.id)
        } else {
          this.addBookmark({ bookmark: this.company.id })
        }
        this.getCompanyDetails()
      } else {
        this.$router.push({
          name: 'buyer-login'
        })
      }
    },

    backToResults () {
      this.$router.go(-1)
    },

    handleRedirectFilter () {
      this.$router.push({
        name: 'companies',
        query: {
          keyword_search: this.searchedText
        }
      })
    },

    handleDownloadDocument (url) {
      this.downloading = true
      setTimeout(() => {
        this.downloading = false
      }, 3000)
    }
  }
}
</script>

<style lang="scss" scoped>
.company-details-wrapper {
  .company-cover-wrapper {
    height: 600px;
    overflow: hidden;
    background-size: cover;
    background-position: 50% -85px;
    background-attachment: fixed;
    .logo-name-container {
      position: absolute;
      width: 100%;
      bottom: 0px;
      z-index: 10;
      padding: 20px;
      .logo-name-wrapper {
        color: #ffffff;
      }
    }
  }
  .company-socil-media-container {
    max-width: 550px;
    margin: auto;
    .company-socil-media-wrapper {
      padding: 20px;
    }
  }
  .company-information-container {
    .company-information-wrapper {
      .ivu-card {
        margin-bottom: 20px;
      }
    }
  }
}
</style>

<style lang="scss">
.company-details-wrapper {
  overflow: auto;
  overflow-x: hidden;
  overflow-y: scroll;
  .page-menu {
    .ivu-menu {
      width: fit-content;
      margin: auto;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .07);
      background: transparent;
      box-shadow: none;
      .ivu-menu-item {
        font-weight: bold;
        color: $primary;
        border-bottom: 2px solid $primary;
      }
    }
  }
  .search-container {
    input.ivu-input {
      height: 50px;
    }
  }
}
</style>
